export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '龙舟奖励配置';
